/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-05-11",
    versionChannel: "nightly",
    buildDate: "2024-05-11T00:06:16.907Z",
    commitHash: "272c07ea3b82371eb0a5a3a6db2cac72517ccde4",
};
